module.exports = __webpack_public_path__ + "static/img/brand-5.430a7b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brand-5.svg
// module id = 3YVP
// module chunks = 0